import React, { ChangeEvent } from 'react'

import { QuickKeyColour } from './utils/qk.constants'

interface Props {
  onChange: (colour: QuickKeyColour) => void
  selectedColour: QuickKeyColour
}

/**
 * Component for rendering the range of available quick key colors.
 */
export const QuickKeyColourPalette: React.FC<Props> = ({
  onChange,
  selectedColour,
}) => {
  const handler = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as QuickKeyColour)
  }

  return (
    <ul className="vd-qk-color-palette">
      {Object.keys(QuickKeyColour).map(key => {
        const colour = (QuickKeyColour as any)[key] as QuickKeyColour
        return (
          <li key={key} className="vd-qk-color-palette-item">
            <label>
              <input
                type="radio"
                name="quickKeyColor"
                className="vd-qk-color-palette-input"
                checked={selectedColour === colour}
                value={colour}
                onChange={handler}
              />
              <span
                className={`vd-qk-color-palette-color vd-qk-color-palette-color--${colour}`}
              />
            </label>
          </li>
        )
      })}
    </ul>
  )
}
